import { useEffect } from 'react'
import { browserHistory } from '../../App'
import { useFormSaveStore } from '../../utils'
import { Location, Action } from 'history'

export const FormSavePrompt = () => {
    const { hasChanges, skipPromptOnce, clearPromptSkip } = useFormSaveStore()
    useEffect(() => {
        const handleBeforeUnload = (e: BeforeUnloadEvent) => {
            if (!hasChanges) return
            e.preventDefault()
            e.returnValue = ''
        }

        window.addEventListener('beforeunload', handleBeforeUnload)
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload)
        }
    }, [hasChanges])
    useEffect(() => {
        const unblock = browserHistory.block((location: Location, action: Action) => {
            if (!hasChanges || skipPromptOnce) {
                clearPromptSkip()
                return
            }
            return 'You have unsaved changes. Are you sure you want to leave this page?'
        })
        return () => {
            unblock()
        }
    }, [hasChanges, skipPromptOnce, clearPromptSkip])

    return null
}
